import React, { Component } from 'react';
import { connect } from 'react-redux';
import NotificationSystem from 'react-notification-system';

export class Notifications extends Component {

  notificationSystem;

  componentDidMount() {
    this.notificationSystem = this.refs.notificationSystem;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.error !== nextProps.error) {
      this.showError(nextProps.error.message);
    }
    return false;
  }

  showError = message => {
    this.notificationSystem.addNotification({
      message,
      level: 'error'
    });
  };

  render() {
    return (
      <div>
        <NotificationSystem ref="notificationSystem" />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    notification: state.notifications.notification,
    error: state.notifications.error
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);



// WEBPACK FOOTER //
// ./src/containers/notifications/Notifications.js